/**
 * homeService — a Home do Admin, decidida no SERVIDOR.
 *
 * ⚠️ Este serviço faz UMA chamada e recebe os cards **já ordenados**, com ênfase e visibilidade
 * resolvidas. O Admin não decide nada: não filtra, não reordena, não esconde.
 *
 * Por que assim: as regras de exibição viviam em `&&` no meio do JSX do `DashboardPage`, e mudar
 * qualquer uma ("quem já tem domínio não vê a oferta") exigia rebuild + deploy do front. Com a
 * decisão no backend, vira ajuste de API. Ver docs/PLANO-REDESENHO-HOME.md (decisão D2).
 */
import api from './api';

const homeService = {
  /**
   * O retrato da Home para o usuário autenticado.
   *
   * O envelope de cada card é FECHADO e só tem campos de negócio; a aparência é decidida no
   * Admin. O `data` é o RESUMO daquele escopo, com schema próprio por `key` — ver
   * `src/pages/dashboard/dashboard.vm.js` (@v2).
   *
   * @returns {Promise<{
   *   greeting: { title: string, subtitle: string },
   *   cards: Array<{
   *     key: string, title: string, subtitle?: string, order: number,
   *     status: 'neutral'|'info'|'success'|'warning'|'error',
   *     importance: 'critical'|'high'|'normal'|'low',
   *     dismissible: boolean, actions: object[], data: object
   *   }>,
   *   banner?: object|null
   * }>}
   */
  async getHome() {
    const res = await api.get('/v1/home');
    return res.data;
  },
};

export default homeService;
